import { SeverityLevel, withScope, captureException as capture } from '@sentry/capacitor'

export const captureException = (error: any, level: SeverityLevel, tag?: string) => {
  withScope(function (scope) {
    scope.setLevel(level)
    tag && scope.setTag('internal-capture', tag)

    const normalizedError =
      error instanceof Error
        ? error
        : new Error(
            typeof error === 'string'
              ? error
              : typeof error === 'object'
                ? error?.message || JSON.stringify(error)
                : String(error),
            { cause: error },
          )

    scope.setExtra('name', normalizedError.name)
    scope.setExtra('message', normalizedError.message)
    scope.setExtra('stack', normalizedError.stack)
    capture(normalizedError, () => scope)
  })
}
